import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import RadioList from '../RadioList/RadioList';
import CollectionBtnWrapper from '../CollectionBtnWrapper/CollectionBtnWrapper';
import CollectionBadge from '../CollectionBadge/CollectionBadge';
import Image from '../Image';
import CustomCollectionFeaturedBadge from '../CustomCollectionFeaturedBadge/CustomCollectionFeaturedBadge';
import SwymWishlistBtn from '../SwymWishlistBtn/SwymWishlistBtn';
import OkendoReviewStars from '../OkendoReviewStars/OkendoReviewStars';
import CollectionCardPrice from '../CollectionCardPrice/CollectionCardPrice';

import useFetch from '../../hooks/useFetch';
import useSelectedVariant from '../../hooks/useSelectedVariant';

import { getProductHref } from '../../Utils/ProductUtils';
import { getCookie, removeCookie } from '../../Utils/FormUtils';

import { StyledImageWrapper, StyledSwatchContainer, StyledInfoWrapper, StyledTitle } from './CollectionCardStyles';

var _ref = React.createElement(CustomCollectionFeaturedBadge, null);

var CollectionCard = function CollectionCard(props) {
  var isMounted = useRef(false);
  // dropdown option is any option that is not color or title
  var dropdownOption = props.product.options.find(function (option) {
    var optionName = option.name.toLowerCase();
    return optionName != 'color' && optionName != 'title' && optionName != 'digital gift card amount';
  });

  var priceRange = parseInt(props.product.priceRange.minVariantPrice.amount) != parseInt(props.product.priceRange.maxVariantPrice.amount);

  // showFromPriceRange if there is a price range &&  dropdown options

  var _useState = useState(priceRange && dropdownOption !== undefined),
      _useState2 = _slicedToArray(_useState, 2),
      showFromPriceRange = _useState2[0],
      setShowFromPriceRange = _useState2[1];

  var variantInventoryData = useFetch('/products/' + props.product.handle + '?view=variant-inventory');

  var _useSelectedVariant = useSelectedVariant(props.product),
      _useSelectedVariant2 = _slicedToArray(_useSelectedVariant, 2),
      selected = _useSelectedVariant2[0],
      handleOptionChange = _useSelectedVariant2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      image = _useState4[0],
      setImage = _useState4[1];

  useEffect(function () {
    isMounted.current = true;
    if (isMounted.current && selected.variant.image) {
      setImage(selected.variant.image.productImg);
    }

    return function () {
      return isMounted.current = false;
    };
  }, [selected.variant, props.product]);

  var handleMouseEnterImage = function handleMouseEnterImage() {
    if (props.product.images.edges[1]) {
      setImage(props.product.images.edges[1].node.productImg);
    }
  };

  var handleMouseLeaveImage = function handleMouseLeaveImage() {
    //AB TEST
    if (selected.variant.image) {
      setImage(selected.variant.image.productImg);
    }
  };

  var handleCollectionBtnWrapperEnter = function handleCollectionBtnWrapperEnter() {
    // on mouse enter, remove from range
    // show selected variant price
    setShowFromPriceRange(false);
  };

  var productHref = getProductHref(props.product.handle, selected.variant.id);

  // only run on regular collection pages and non touch devices
  var showAltImage = !props.customCollection && !props.isTouchDevice;

  return React.createElement(
    'li',
    null,
    React.createElement(
      StyledImageWrapper,
      {
        href: productHref,
        'aria-label': 'Go to ' + props.product.title,
        onMouseEnter: showAltImage ? handleMouseEnterImage : null,
        onMouseLeave: showAltImage ? handleMouseLeaveImage : null
      },
      React.createElement(SwymWishlistBtn, {
        product: props.product,
        selectedVariant: selected.variant,
        isWishlistProduct: props.isWishlistProduct,
        toggleAccountModal: props.toggleAccountModal
      }),
      props.customCollection ? props.product.featured && _ref : React.createElement(CollectionBadge, {
        tags: props.product.tags,
        newFromDate: props.product.newFromDate,
        newToDate: props.product.newToDate,
        preorderDate: selected.variant.preorderDate,
        productPreorderDate: props.product.preorderDate,
        selectedVariantInventory: variantInventoryData && variantInventoryData[selected.variant.title],
        lowStockThreshold: props.lowStockThreshold
      }),
      image !== null && React.createElement(Image, { src: image, alt: props.product.title + ' Image' })
    ),
    React.createElement(
      StyledSwatchContainer,
      null,
      props.product.options.map(function (option) {
        if (option.name.toLowerCase() == 'color' && option.values.length > 1) {
          return React.createElement(RadioList, {
            key: option.id.toString(),
            handleOptionChange: handleOptionChange,
            option: option,
            selectedOptions: selected.options,
            selectedOption: selected.options[option.name],
            selectedVariant: selected.variant,
            variants: props.product.variants.edges,
            productId: props.product.id,
            parent: 'CollectionCard__swatch-container'
          });
        }
      })
    ),
    React.createElement(CollectionBtnWrapper, {
      options: props.product.options,
      selectedVariant: selected.variant,
      selectedVariantQuantity: 1,
      addVariantToCart: props.addVariantToCart,
      variants: props.product.variants.edges,
      handleOptionChange: handleOptionChange,
      selectedOptions: selected.options,
      product: props.product,
      customCollection: props.customCollection,
      collectionTitle: props.collectionTitle,
      openProductModal: props.openProductModal,
      dropdownOption: dropdownOption,
      handleCollectionBtnWrapperEnter: handleCollectionBtnWrapperEnter
    }),
    React.createElement(
      StyledInfoWrapper,
      null,
      React.createElement(
        StyledTitle,
        { href: productHref },
        props.product.title
      ),
      props.product.productListingSnippet && React.createElement(OkendoReviewStars, {
        okendoSnippet: props.product.productListingSnippet.value,
        okendoReviewCount: props.product.reviewCount.value,
        isCollectionCard: true
      }),
      props.product.variants && React.createElement(CollectionCardPrice, {
        selectedVariant: selected.variant,
        showPriceRange: showFromPriceRange,
        priceRange: props.product.priceRange,
        variants: props.product.variants
      })
    )
  );
};

CollectionCard.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  collectionTitle: PropTypes.string,
  isWishlistProduct: PropTypes.bool,
  customCollection: PropTypes.bool,
  isTouchDevice: PropTypes.bool,
  openProductModal: PropTypes.func,
  toggleAccountModal: PropTypes.func.isRequired,
  lowStockThreshold: PropTypes.string
};

export default CollectionCard;